import { config } from "./config";

const ChildrenGroups = () => import("@/components/Module/List.vue");
const ChildrenGroup = () => import("./views/ChildrenGroup.vue");
const ChildrenGroupEdit = () => import("./views/ChildrenGroupEdit.vue");

export default [
  {
    path: config.route,
    name: `${config.name}.list`,
    component: ChildrenGroups,

    props: {
      config,
    },

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${config.route}/create`,
    name: `${config.name}.create`,
    component: ChildrenGroupEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${config.route}/:itemId`,
    name: `${config.name}.details`,
    component: ChildrenGroup,

    props: (route) => ({
      itemId: +route.params.itemId,
    }),

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${config.route}/:itemId/edit`,
    name: `${config.name}.edit`,
    component: ChildrenGroupEdit,

    props: (route) => ({
      itemId: +route.params.itemId,
    }),

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
